import styled from "@emotion/styled"
import { LayoutContext } from "contexts/LayoutProvider"
import { useContext } from "react"
import colors from "theme/colors"
import { TitleWithLine } from "ui"
import { extractProperty } from "utils"
import { replaceHrefsWithMediaUrl } from "utils/utils"

const RegulationWrapperDiv = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 30px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    margin-top: 36px;
  }
  ol {
    padding-left: 20px;
  }
  ol,
  li {
    list-style-type: decimal;
  }
  li {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    margin-top: 4px;
    padding-left: 12px;
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 12px;
      line-height: 18px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
      font-size: 16px;
      line-height: 24px;
    }
  }
  p {
    margin: 0px;
  }
  h4 {
    margin-top: 20px;
    margin-bottom: 12px;
    color: ${colors.blue};
    font-size: 20px;
    u {
      text-decoration: none;
    }
  }
  h2 {
    margin-bottom: 16px;
  }
  table {
    margin-top: 20px;
    margin-bottom: 32px;
    width: 100%;
    td {
      border-bottom: 1px solid #bad2d4;
      padding: 16px;
    }
  }
  a{
   &:hover, &:focus {
    text-decoration: none;
   }
  }
`

type RegulationWrapperProps = {
  data: any
  isFirstHeading?: boolean
}
const RegulationWrapper = ({ data, isFirstHeading }: RegulationWrapperProps) => {
  const contentTitle = extractProperty(data, "conetntTitle")
  const htmlText = extractProperty(data, "innerText")
  const { GRAPHQL_URL } = useContext(LayoutContext)

  return (
    <RegulationWrapperDiv>
      <TitleWithLine
        component={isFirstHeading ? "h1" : "h2"}
        title={contentTitle}
        titleColor={colors.black}
        titleFontSize={64}
        mobileTitleFontSize={36}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: replaceHrefsWithMediaUrl(htmlText.trim(), GRAPHQL_URL),
        }}
      />
    </RegulationWrapperDiv>
  )
}
export default RegulationWrapper
